export default {
    CHECKOUT_REGISTRATION: 'checkout-registration',
    CHECKOUT_GUEST: 'checkout-guest',
    CHECKOUT_AUTH_OPTIONS: 'checkout-auth-options',
    CHANGE_BILLING_ADDRESS_FORM: 'changeBillingAddressForm',
    DELIVERY_ADDRESS_FOR_LOGGED_IN_USER_FORM: 'deliveryAddressForLoggedInUserForm',
    CHECKOUT_ADD_ADDRESS_FORM: 'checkoutAddAddressForm',
    CHECKOUT_GUEST_TO_LOGIN_FORM: 'checkoutGuestToLoginForm',
};
